<template>
<div class="chapter">
<div class="inner_page">
<p class="titlea"><span class="bold">LandCraft 4</span></p>
<h1 class="title"><span class="bold">STRYKER</span></h1>
<p class="subtitle"><span class="bold">INTERIM CO M B AT VEHICLE</span></p>
<p class="subtitle1"><span class="bold">THE STRYKER AND LAV III IN US AND CANADIAN SERVICE, 1999-2020</span></p>
<p class="author"><span class="bold">David Grummitt</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?b7acd942